import React from 'react';
import PropTypes from 'prop-types';

import { LocaleService } from '@sm360/widget-commons-core-services';

import LocalConfigsService from 'login/services/ConfigsService/ConfigsService.js';

import 'login/components/Library/LoadingButton/style.scss';

const LoadingButton = ({ btnCallback, btnEnabled, text, dataTest }) => {
    const content = (
        <button
            className="button formfield--submit sr-button-1"
            onClick={btnCallback}
            disabled={!btnEnabled}
            data-test={dataTest}
        >
            {text}
        </button>
    );

    const spinner = btnEnabled || (
        <span className="loading-animation">
            <img src={LocalConfigsService.getLoadingImageUrl()} alt={LocaleService.t('LOGIN.LOADING')} />
        </span>
    );

    return (
        <div className="LoadingButton">
            <div className="btn-loading-wrapper">
                {content}
                {spinner}
            </div>
        </div>
    );
};

LoadingButton.defaultProps = {
    dataTest: '',
};

LoadingButton.propTypes = {
    text: PropTypes.string.isRequired,
    btnCallback: PropTypes.func.isRequired,
    btnEnabled: PropTypes.bool.isRequired,
    dataTest: PropTypes.string,
};

LoadingButton.displayName = 'LoadingButton';

export default LoadingButton;
